import type { CSSProperties } from "react";

interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  radius?: string | number;
  className?: string;
  style?: CSSProperties;
  /** Render as inline-block (default true so it sits inside text blocks). */
  inline?: boolean;
}

/**
 * Shimmer-style placeholder block. Use to indicate that data is still being
 * fetched without changing layout once the real content arrives.
 */
export function Skeleton({
  width = "100%",
  height = "1em",
  radius = "6px",
  className = "",
  style,
  inline = true,
}: SkeletonProps) {
  return (
    <span
      className={`events-skeleton ${className}`.trim()}
      aria-hidden="true"
      style={{
        display: inline ? "inline-block" : "block",
        width: typeof width === "number" ? `${width}px` : width,
        height: typeof height === "number" ? `${height}px` : height,
        borderRadius: typeof radius === "number" ? `${radius}px` : radius,
        ...style,
      }}
    />
  );
}

/** A single row of skeleton cells used inside a `<tbody>`. */
export function SkeletonTableRow({ columns }: { columns: number }) {
  return (
    <tr aria-hidden="true">
      {Array.from({ length: columns }).map((_, idx) => (
        <td key={idx}>
          <Skeleton height="0.9em" />
        </td>
      ))}
    </tr>
  );
}
